import { BackToLoginLink, Rule } from 'components/core-v2'
import { ContactUs } from 'components/core-v2/organisms/forms/reset-password-request/contact-us'

import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

const MainElement = () => (
  <>
    <p style={{ margin: '0' }}>
      Please check your email inbox for instructions on resetting your account.
    </p>
    <BackToLoginLink className="mt-4" />
    <Rule className="my-12" />
    <ContactUs />
  </>
)

export const ResetPasswordSent = () => (
  <TwoColumnWithImage mainElement={<MainElement />} title={COPY.resetPassword.title} />
)
